module.exports = __webpack_public_path__ + "img/images_splash.3897b5a3.jpg";